import produce from "immer";
import names, { MessageSearchActionTypes } from "./messageListActionTypes";
import { MessageListingState } from "./messageListingState";

export const messageListingReducer = (
    state: MessageListingState,
    action: MessageSearchActionTypes
): MessageListingState =>
    produce(state, draft => {
        draft.error = undefined;
        switch (action.type) {
            case names.SEARCH_MESSAGES: {
                draft.searchCriteria = action.payload.criteria;
                draft.selectedMessages = [];
                draft.loadingMessages = true;
                break;
            }
            case names.SEARCH_MESSAGES_SUCCESS: {
                draft.loadingMessages = false;
                draft.selectedMessages = [];
                if (
                    action.payload.results.totalPages > 0 &&
                    draft.searchCriteria.pageIndex >
                        action.payload.results.totalPages
                ) {
                    draft.searchCriteria.pageIndex =
                        action.payload.results.totalPages;
                } else {
                    draft.searchResults = action.payload.results;
                }
                break;
            }

            case names.SEARCH_MESSAGES_FAILURE: {
                draft.loadingMessages = false;
                draft.error = action.payload.error;
                break;
            }

            case names.SET_SEARCH_CRITERIA: {
                draft.searchCriteria = action.payload.criteria;
                break;
            }
            case names.NAVIGATE: {
                const index =
                    state.searchCriteria.pageIndex +
                    (action.payload.direction === "next" ? 1 : -1);
                if (index <= state.searchResults.totalPages && index >= 0) {
                    draft.searchCriteria.pageIndex = index;
                }
                break;
            }

            case names.SORT_MESSAGES: {
                let dir: SortDir = "asc";
                if (draft.searchCriteria.sortField === action.payload.field) {
                    dir =
                        draft.searchCriteria.sortDir === "asc" ? "desc" : "asc";
                }
                draft.searchCriteria.sortDir = dir;
                draft.searchCriteria.sortField = action.payload.field;
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.FILTER_MESSAGES: {
                if (
                    action.payload.facet.item &&
                    action.payload.facet.item.value
                ) {
                    draft.searchCriteria[action.payload.facet.id] = parseFloat(
                        action.payload.facet.item.value
                    );
                    draft.searchCriteria[action.payload.facet.name] =
                        action.payload.facet.item.label;
                } else {
                    draft.searchCriteria[action.payload.facet.id] = undefined;
                    draft.searchCriteria[action.payload.facet.name] = undefined;
                }
                draft.searchCriteria.pageIndex = 1;
                break;
            }

            case names.SET_MESSAGES_READ: {
                draft.settingMessageRead = true;
                break;
            }

            case names.SET_MESSAGE_CHECKED: {
                if (
                    state.selectedMessages.findIndex(
                        m => m === action.payload.id
                    ) < 0
                ) {
                    draft.selectedMessages.push(action.payload.id);
                }
                break;
            }

            case names.SET_MESSAGE_UNCHECKED: {
                draft.selectedMessages = draft.selectedMessages.filter(
                    x => x !== action.payload.id
                );
                break;
            }

            case names.DESELECT_ALL_MESSAGES: {
                draft.selectedMessages = [];
                break;
            }

            case names.SELECT_ALL_MESSAGES: {
                draft.selectedMessages = state.searchResults.messages.map(
                    m => m.messageId
                );
                break;
            }
        }
    });
